/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  // Helmet Page Titles
  HELMET_DETAILS_PAGETITLE: 'mortgage.helmet.details.pageTitle',
  HELMET_DETAILS_PAGETITLE_ERROR: 'mortgage.helmet.details.pageTitle.error',
  HELMET_ESCROW_PAGETITLE: 'mortgage.helmet.escrow.pageTitle',
  HELMET_ESCROW_PAGETITLE_CONFIRMATION: 'mortgage.helmet.escrow.pageTitle.confirmation',
  HELMET_ESCROW_PAGETITLE_ERROR: 'mortgage.helmet.escrow.pageTitle.error',
  HELMET_ESCROW_PAGETITLE_SELECT_TYPE: 'mortgage.helmet.escrow.pageTitle.selectType',
  HELMET_ESCROW_PAGETITLE_UPLOAD_HOMEOWNERS_DECLARATION: 'mortgage.helmet.escrow.pageTitle.uploadHomeownersDeclaration',
  HELMET_ESCROW_PAGETITLE_UPLOAD_PROPERTY_TAX_BILL: 'mortgage.helmet.escrow.pageTitle.uploadPropertyTaxBill',
  HELMET_ESCROWHISTORY_PAGETITLE: 'mortgage.helmet.escrowhistory.pageTitle',
  HELMET_ESCROWHISTORY_PAGETITLE_ERROR: 'mortgage.helmet.escrowhistory.pageTitle.error',
  HELMET_HELOCDRAW_PAGETITLE: 'mortgage.helmet.helocdraw.pageTitle',
  HELMET_HELOCDRAW_PAGETITLE_CONFIRMATION: 'mortgage.helmet.helocdraw.pageTitle.confirmation',
  HELMET_HELOCDRAW_PAGETITLE_ERROR: 'mortgage.helmet.helocdraw.pageTitle.error',
  HELMET_HELOCDRAW_PAGETITLE_REVIEW: 'mortgage.helmet.helocdraw.pageTitle.review',
  HELMET_INSURANCEDETAILS_PAGETITLE: 'mortgage.helmet.insurancedetails.pageTitle',
  HELMET_INSURANCEDETAILS_PAGETITLE_ERROR: 'mortgage.helmet.insurancedetails.pageTitle.error',
  HELMET_INSURANCEUPLOAD_PAGETITLE: 'mortgage.helmet.insuranceupload.pageTitle',
  HELMET_INSURANCEUPLOAD_PAGETITLE_CONFIRMATION: 'mortgage.helmet.insuranceupload.pageTitle.confirmation',
  HELMET_INSURANCEUPLOAD_PAGETITLE_ERROR: 'mortgage.helmet.insuranceupload.pageTitle.error',
  HELMET_PAGETITLE_ERROR: 'mortgage.helmet.pageTitle.error',
  HELMET_SECTIONTITLE_MORTGAGE: 'mortgage.helmet.sectionTitle.mortgage',
  HELMET_TAXESINSURANCE_PAGETITLE: 'mortgage.helmet.taxesinsurance.pageTitle',
  HELMET_TAXESINSURANCE_PAGETITLE_ERROR: 'mortgage.helmet.taxesinsurance.pageTitle.error',
  // Mortgage Home
  MORTGAGE_HOME_HEADER_TEXT: 'mortgage.home.header.text',
  MORTGAGE_HOME_HEADER_TITLE: 'mortgage.home.header.title',
  MORTGAGE_HOME_OVERVIEW_LABEL_CURRENTINTERESTRATE: 'mortgage.home.overview.label.CurrentInterestRate',
  MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANAMOUNT: 'mortgage.home.overview.label.OriginaLoanAmount',
  MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANDATE: 'mortgage.home.overview.label.OriginalLoanDate',
  MORTGAGE_HOME_OVERVIEW_LABEL_PRINCIPALBALANCE: 'mortgage.home.overview.label.PrincipalBalance',
  MORTGAGE_HOME_OVERVIEW_LINK_LABEL_MORTGAGE_DETAILS: 'mortgage.home.overview.link.label.mortgage.details',
  MORTGAGE_HOME_OVERVIEW_TITLE: 'mortgage.home.overview.title',
  MORTGAGE_HOME_TITLE: 'mortgage.home.title',
  MORTGAGE_HOME_TITLE_MORTGAGE_FEATURES: 'mortgage.home.title.mortgage.features',
  // Mortgage Details
  // eslint-disable-next-line sort-keys
  MORTGAGE_DETAILS_LABEL_ANNUALINTERESTRATE: 'mortgage.details.label.AnnualInterestRate',
  MORTGAGE_DETAILS_LABEL_AVAILABLEADVANCEAMOUNT: 'mortgage.details.label.AvailableAdvanceAmount',
  MORTGAGE_DETAILS_LABEL_CREDITLINEAMOUNT: 'mortgage.details.label.CreditLineAmount',
  MORTGAGE_DETAILS_LABEL_CURRENTINTERESTAMOUNT: 'mortgage.details.label.CurrentInterestAmount',
  MORTGAGE_DETAILS_LABEL_CURRENTINTERESTRATE: 'mortgage.details.label.CurrentInterestRate',
  MORTGAGE_DETAILS_LABEL_CURRENTMINIMUMPAYMENTAMOUNT: 'mortgage.details.label.CurrentMinimumPaymentAmount',
  MORTGAGE_DETAILS_LABEL_DESCRIPTION: 'mortgage.details.label.Description',
  MORTGAGE_DETAILS_LABEL_DRAWPERIODENDDATE: 'mortgage.details.label.DrawPeriodEndDate',
  MORTGAGE_DETAILS_LABEL_FIRSTPAYMENTDUEDATE: 'mortgage.details.label.FirstPaymentDueDate',
  MORTGAGE_DETAILS_LABEL_INDEXNAME: 'mortgage.details.label.IndexName',
  MORTGAGE_DETAILS_LABEL_INDEXRATE: 'mortgage.details.label.IndexRate',
  MORTGAGE_DETAILS_LABEL_INTERESTAMOUNT: 'mortgage.details.label.InterestAmount',
  MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMCEILING: 'mortgage.details.label.InterestMaximumCeiling',
  MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMDECREASE: 'mortgage.details.label.InterestMaximumDecrease',
  MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMINCREASE: 'mortgage.details.label.InterestMaximumIncrease',
  MORTGAGE_DETAILS_LABEL_INTERESTMINIMUMFLOOR: 'mortgage.details.label.InterestMinimumFloor',
  MORTGAGE_DETAILS_LABEL_INTERESTRATE: 'mortgage.details.label.InterestRate',
  MORTGAGE_DETAILS_LABEL_INTERESTRATECHANGEFREQUENCY: 'mortgage.details.label.InterestRateChangeFrequency',
  MORTGAGE_DETAILS_LABEL_LASTADVANCEDATE: 'mortgage.details.label.LastAdvanceDate',
  MORTGAGE_DETAILS_LABEL_LINEAMOUNT: 'mortgage.details.label.LineAmount',
  MORTGAGE_DETAILS_LABEL_LOANTERM: 'mortgage.details.label.LoanTerm',
  MORTGAGE_DETAILS_LABEL_LOANTYPE: 'mortgage.details.label.LoanType',
  MORTGAGE_DETAILS_LABEL_MARGIN: 'mortgage.details.label.Margin',
  MORTGAGE_DETAILS_LABEL_MATURITYDATE: 'mortgage.details.label.MaturityDate',
  MORTGAGE_DETAILS_LABEL_MINIMUMPAYMENTAMOUNT: 'mortgage.details.label.MinimumPaymentAmount',
  MORTGAGE_DETAILS_LABEL_NEXTINTERESTRATE: 'mortgage.details.label.NextInterestRate',
  MORTGAGE_DETAILS_LABEL_NEXTPRINCIPALANDINTERESTPAYMENTAMOUNT: 'mortgage.details.label.NextPrincipalandInterestPaymentAmount',
  MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDINTERESTRATECHANGE: 'mortgage.details.label.NextScheduledInterestRateChange',
  MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDPRINCIPALANDINTERESTCHANGE: 'mortgage.details.label.NextScheduledPrincipalandInterestChange',
  MORTGAGE_DETAILS_LABEL_ORIGINALINTERESTRATECHANGEDATE: 'mortgage.details.label.OriginalInterestRateChangeDate',
  MORTGAGE_DETAILS_LABEL_ORIGINALLOANAMOUNT: 'mortgage.details.label.OriginalLoanAmount',
  MORTGAGE_DETAILS_LABEL_ORIGINALLOANDATE: 'mortgage.details.label.OriginalLoanDate',
  MORTGAGE_DETAILS_LABEL_ORIGINALMORTGAGEAMOUNT: 'mortgage.details.label.OriginalMortgageAmount',
  MORTGAGE_DETAILS_LABEL_ORIGINALPICHANGEDATE: 'mortgage.details.label.OriginalPiChangeDate',
  MORTGAGE_DETAILS_LABEL_PAYMENTCHANGEFREQUENCY: 'mortgage.details.label.PaymentChangeFrequency',
  MORTGAGE_DETAILS_LABEL_PLANID: 'mortgage.details.label.PlanId',
  MORTGAGE_DETAILS_LABEL_PRINCIPALANDINTEREST: 'mortgage.details.label.PrincipalAndInterest',
  MORTGAGE_DETAILS_LABEL_PRINCIPALBALANCE: 'mortgage.details.label.PrincipalBalance',
  MORTGAGE_DETAILS_LABEL_ROUNDINGFACTOR: 'mortgage.details.label.RoundingFactor',
  MORTGAGE_DETAILS_LABEL_SEGMENT: 'mortgage.details.label.Segment',
  MORTGAGE_DETAILS_LABEL_SEGMENTNUMBER: 'mortgage.details.label.SegmentNumber',
  MORTGAGE_DETAILS_LABEL_TERMEXPIRATIONDATE: 'mortgage.details.label.TermExpirationDate',
  MORTGAGE_DETAILS_LABEL_TOTALCREDIT: 'mortgage.details.label.TotalCredit',
  MORTGAGE_DETAILS_LABEL_TOTALDUEAMOUNT: 'mortgage.details.label.TotalDueAmount',
  MORTGAGE_DETAILS_LABEL_UNDISBURSEDFUNDS: 'mortgage.details.label.UndisbursedFunds',
  MORTGAGE_DETAILS_SUBHEADER_ARMDETAILS: 'mortgage.details.subheader.ArmDetails',
  MORTGAGE_DETAILS_SUBHEADER_CONSTRUCTIONINFORMATION: 'mortgage.details.subheader.ConstructionInformation',
  MORTGAGE_DETAILS_SUBHEADER_HELOCAVAILABLEBALANCE: 'mortgage.details.subheader.HELOCAvailableBalance',
  MORTGAGE_DETAILS_SUBHEADER_PRINCIPALBALANCE: 'mortgage.details.subheader.PrincipalBalance',
  MORTGAGE_DETAILS_SUBHEADER_SECONDLOANPRINCIPALBALANCE: 'mortgage.details.subheader.SecondLoanPrincipalBalance',
  MORTGAGE_DETAILS_SUBHEADER_SEGMENTEDHELOC: 'mortgage.details.subheader.SegmentedHELOC',
  MORTGAGE_DETAILS_TITLE: 'mortgage.details.title',
  MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_LOANTYPE: 'mortgage.taxesinsurance.escrow.card.LoanType',
  MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_ORIGINALLOANDATE: 'mortgage.taxesinsurance.escrow.card.OriginalLoanDate',
  // Escrow
  // eslint-disable-next-line sort-keys
  MORTGAGE_ESCROW_ADD_CONFIRMATION_LABEL_LOANNUMBER: 'mortgage.escrow.add.confirmation.label.LoanNumber',
  MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_1: 'mortgage.escrow.splash.benefits.text.1',
  MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_2: 'mortgage.escrow.splash.benefits.text.2',
  MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_3: 'mortgage.escrow.splash.benefits.text.3',
  MORTGAGE_ESCROW_SPLASH_DEFINITION_CARD_TEXT: 'mortgage.escrow.splash.definition.card.text',
  // Insurance Upload
  // eslint-disable-next-line sort-keys
  MORTGAGE_ESCROW_INSURANCE_UPLOAD_LABEL_LOANNUMBER: 'mortgage.escrow.insurance.upload.label.LoanNumber',
  // Shared
  MORTGAGE_SHARED_BUTTON_LABEL_BACKTOMORTGAGE: 'mortgage.shared.button.label.BacktoMortgage',
  MORTGAGE_SHARED_BUTTON_LABEL_RETURNTOMORTGAGE: 'mortgage.shared.button.label.ReturntoMortgage',
};

const enMessages = {
  // Helmet Page Titles
  [IDS.HELMET_DETAILS_PAGETITLE]: 'Mortgage Details',
  [IDS.HELMET_DETAILS_PAGETITLE_ERROR]: 'Mortgage Details Error',
  [IDS.HELMET_ESCROW_PAGETITLE]: 'Set Up Escrow',
  [IDS.HELMET_ESCROW_PAGETITLE_SELECT_TYPE]: 'Select Escrow Type',
  [IDS.HELMET_ESCROW_PAGETITLE_UPLOAD_HOMEOWNERS_DECLARATION]: 'Upload Homeowners Declaration',
  [IDS.HELMET_ESCROW_PAGETITLE_UPLOAD_PROPERTY_TAX_BILL]: 'Upload Property Tax Bill',
  [IDS.HELMET_ESCROW_PAGETITLE_CONFIRMATION]: 'Set Up Escrow Confirmation',
  [IDS.HELMET_ESCROW_PAGETITLE_ERROR]: 'Set Up Escrow Error',
  [IDS.HELMET_ESCROWHISTORY_PAGETITLE]: 'Escrow History',
  [IDS.HELMET_ESCROWHISTORY_PAGETITLE_ERROR]: 'Escrow History Error',
  [IDS.HELMET_HELOCDRAW_PAGETITLE]: 'HELOC Draw',
  [IDS.HELMET_HELOCDRAW_PAGETITLE_CONFIRMATION]: 'HELOC Draw Confirmation',
  [IDS.HELMET_HELOCDRAW_PAGETITLE_ERROR]: 'HELOC Draw Error',
  [IDS.HELMET_HELOCDRAW_PAGETITLE_REVIEW]: 'HELOC Draw Review',
  [IDS.HELMET_INSURANCEDETAILS_PAGETITLE]: 'Update Insurance Policy',
  [IDS.HELMET_INSURANCEDETAILS_PAGETITLE_ERROR]: 'Insurance Details Error',
  [IDS.HELMET_INSURANCEUPLOAD_PAGETITLE]: 'Upload Document',
  [IDS.HELMET_INSURANCEUPLOAD_PAGETITLE_CONFIRMATION]: 'Insurance Upload Confirmation',
  [IDS.HELMET_INSURANCEUPLOAD_PAGETITLE_ERROR]: 'Insurance Upload Error',
  [IDS.HELMET_PAGETITLE_ERROR]: 'Error',
  [IDS.HELMET_TAXESINSURANCE_PAGETITLE]: 'Taxes & Insurance Details',
  [IDS.HELMET_TAXESINSURANCE_PAGETITLE_ERROR]: 'Taxes & Insurance Details Error',
  // Helmet Section Titles
  [IDS.HELMET_SECTIONTITLE_MORTGAGE]: 'Mortgage',
  // Mortgage Home
  [IDS.MORTGAGE_HOME_HEADER_TEXT]: 'View mortgage, taxes, and insurance details.',
  [IDS.MORTGAGE_HOME_HEADER_TITLE]: 'Your loan information, all in one place',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_CURRENTINTERESTRATE]: 'Current Interest Rate',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANAMOUNT]: 'Original Loan Amount',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANDATE]: 'Original Loan Date',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_PRINCIPALBALANCE]: 'Principal Balance',
  [IDS.MORTGAGE_HOME_OVERVIEW_LINK_LABEL_MORTGAGE_DETAILS]: 'See All Mortgage Details',
  [IDS.MORTGAGE_HOME_OVERVIEW_TITLE]: 'Mortgage Overview',
  [IDS.MORTGAGE_HOME_TITLE_MORTGAGE_FEATURES]: 'Mortgage Features',
  [IDS.MORTGAGE_HOME_TITLE]: 'Mortgage',
  // Mortgage Details
  [IDS.MORTGAGE_DETAILS_LABEL_ANNUALINTERESTRATE]: 'Annual Interest Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_AVAILABLEADVANCEAMOUNT]: 'Available Advance Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_CREDITLINEAMOUNT]: 'Credit Line Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_CURRENTINTERESTAMOUNT]: 'Current Interest Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_CURRENTINTERESTRATE]: 'Current Interest Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_CURRENTMINIMUMPAYMENTAMOUNT]: 'Current Minimum Payment Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_DESCRIPTION]: 'Description',
  [IDS.MORTGAGE_DETAILS_LABEL_DRAWPERIODENDDATE]: 'Draw Period End Date',
  [IDS.MORTGAGE_DETAILS_LABEL_FIRSTPAYMENTDUEDATE]: 'First Payment Due Date',
  [IDS.MORTGAGE_DETAILS_LABEL_INDEXNAME]: 'Index Name',
  [IDS.MORTGAGE_DETAILS_LABEL_INDEXRATE]: 'Index Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTAMOUNT]: 'Interest Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMCEILING]: 'Interest Maximum Ceiling',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMDECREASE]: 'Interest Maximum Decrease',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMINCREASE]: 'Interest Maximum Increase',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMINIMUMFLOOR]: 'Interest Minimum Floor',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTRATE]: 'Interest Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTRATECHANGEFREQUENCY]: 'Interest Rate Change Frequency',
  [IDS.MORTGAGE_DETAILS_LABEL_LASTADVANCEDATE]: 'Last Advance Date',
  [IDS.MORTGAGE_DETAILS_LABEL_LINEAMOUNT]: 'Line Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTERM]: 'Loan Term',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTYPE]: 'Loan Type',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTYPE]: 'Loan Type',
  [IDS.MORTGAGE_DETAILS_LABEL_MARGIN]: 'Margin',
  [IDS.MORTGAGE_DETAILS_LABEL_MATURITYDATE]: 'Maturity Date',
  [IDS.MORTGAGE_DETAILS_LABEL_MINIMUMPAYMENTAMOUNT]: 'Minimum Payment Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTINTERESTRATE]: 'Next Interest Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTPRINCIPALANDINTERESTPAYMENTAMOUNT]: 'Next Principal and Interest Payment Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDINTERESTRATECHANGE]: 'Next Scheduled Interest Rate Change',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDPRINCIPALANDINTERESTCHANGE]: 'Next Scheduled Principal and Interest Change',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALINTERESTRATECHANGEDATE]: 'Original Interest Rate Change Date',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANAMOUNT]: 'Original Loan Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANDATE]: 'Original Loan Date',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALMORTGAGEAMOUNT]: 'Original Mortgage Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALPICHANGEDATE]: 'Original Pi Change Date',
  [IDS.MORTGAGE_DETAILS_LABEL_PAYMENTCHANGEFREQUENCY]: 'Payment Change Frequency',
  [IDS.MORTGAGE_DETAILS_LABEL_PLANID]: 'Plan Id',
  [IDS.MORTGAGE_DETAILS_LABEL_PRINCIPALANDINTEREST]: 'Principal And Interest',
  [IDS.MORTGAGE_DETAILS_LABEL_PRINCIPALBALANCE]: 'Principal Balance',
  [IDS.MORTGAGE_DETAILS_LABEL_ROUNDINGFACTOR]: 'Rounding Factor',
  [IDS.MORTGAGE_DETAILS_LABEL_SEGMENT]: 'Segment',
  [IDS.MORTGAGE_DETAILS_LABEL_SEGMENTNUMBER]: 'Segment Number',
  [IDS.MORTGAGE_DETAILS_LABEL_TERMEXPIRATIONDATE]: 'Term Expiration Date',
  [IDS.MORTGAGE_DETAILS_LABEL_TOTALCREDIT]: 'Total Credit',
  [IDS.MORTGAGE_DETAILS_LABEL_TOTALDUEAMOUNT]: 'Total Due Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_UNDISBURSEDFUNDS]: 'Undisbursed Funds*',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_ARMDETAILS]: 'Arm Details',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_CONSTRUCTIONINFORMATION]: 'Construction Information',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_HELOCAVAILABLEBALANCE]: 'HELOC Available Balance',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_PRINCIPALBALANCE]: 'Principal Balance',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_SECONDLOANPRINCIPALBALANCE]: 'Second Loan Principal Balance',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_SEGMENTEDHELOC]: 'Segmented HELOC',
  [IDS.MORTGAGE_DETAILS_TITLE]: 'Mortgage Details',
  [IDS.MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_LOANTYPE]: 'Loan Type',
  [IDS.MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_ORIGINALLOANDATE]: 'Original Loan Date',
  // Escrow
  [IDS.MORTGAGE_ESCROW_ADD_CONFIRMATION_LABEL_LOANNUMBER]: 'Loan Number',
  [IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_1]: 'View the breakdown of principal & interest you will pay over time.',
  [IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_2]: 'Make one monthly payment that includes your mortgage plus a percentage of other expenses.',
  [IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_3]: 'Payments are made on your behalf so you don\'t have to keep track of deadlines',
  [IDS.MORTGAGE_ESCROW_SPLASH_DEFINITION_CARD_TEXT]: 'A trust account in which the lender holds funds collected from a borrower and uses the money to pay taxes and insurance premiums when they become due. An initial escrow account is generally established at settlement. In some parts of the country, escrows of taxes and insurance premiums are called impounds or reserves. Escrow accounts are generally required by most lenders.',
  // Insurance Upload
  [IDS.MORTGAGE_ESCROW_INSURANCE_UPLOAD_LABEL_LOANNUMBER]: 'Loan Number',
  // Shared
  [IDS.MORTGAGE_SHARED_BUTTON_LABEL_BACKTOMORTGAGE]: 'Back to Mortgage',
  [IDS.MORTGAGE_SHARED_BUTTON_LABEL_RETURNTOMORTGAGE]: 'Return to Mortgage',
};

const enMurabahaMessages = {
  ...enMessages,
  // Helmet Page Titles
  [IDS.HELMET_DETAILS_PAGETITLE]: 'Details',
  [IDS.HELMET_DETAILS_PAGETITLE_ERROR]: 'Details Error',
  // Helmet Section Titles
  [IDS.HELMET_SECTIONTITLE_MORTGAGE]: 'Murabaha Financing Transaction',
  // Mortgage Home
  [IDS.MORTGAGE_HOME_HEADER_TEXT]: 'View Murabaha Financing Transaction, taxes, and insurance details.',
  [IDS.MORTGAGE_HOME_HEADER_TITLE]: 'Your account information, all in one place',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_CURRENTINTERESTRATE]: 'Current Profit Rate',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANAMOUNT]: 'Original Murabaha Debt',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_ORIGINALLOANDATE]: 'Original Murabaha Financing Closing Date',
  [IDS.MORTGAGE_HOME_OVERVIEW_LABEL_PRINCIPALBALANCE]: 'Current Murabaha Debt Balance',
  [IDS.MORTGAGE_HOME_OVERVIEW_LINK_LABEL_MORTGAGE_DETAILS]: 'See All Murabaha Financing Transaction Details',
  [IDS.MORTGAGE_HOME_OVERVIEW_TITLE]: 'Murabaha Financing Transaction Overview',
  [IDS.MORTGAGE_HOME_TITLE_MORTGAGE_FEATURES]: 'Murabaha Financing Transaction Features',
  [IDS.MORTGAGE_HOME_TITLE]: 'Murabaha Financing Transaction',
  // Mortgage Details
  [IDS.MORTGAGE_DETAILS_LABEL_ANNUALINTERESTRATE]: 'Annual Profit Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_CURRENTINTERESTAMOUNT]: 'Current Profit Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_CURRENTINTERESTRATE]: 'Current Profit Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTAMOUNT]: 'Profit Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMCEILING]: 'Profit Maximum Ceiling',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMDECREASE]: 'Profit Maximum Decrease',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMAXIMUMINCREASE]: 'Profit Maximum Increase',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTMINIMUMFLOOR]: 'Profit Minimum Floor',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTRATE]: 'Profit Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_INTERESTRATECHANGEFREQUENCY]: 'Profit Rate Change Frequency',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTERM]: 'Murabaha Financing Transaction Term',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTYPE]: 'Account Type',
  [IDS.MORTGAGE_DETAILS_LABEL_LOANTYPE]: 'Murabaha Financing Transaction Type',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTINTERESTRATE]: 'Next Profit Rate',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTPRINCIPALANDINTERESTPAYMENTAMOUNT]: 'Next Installment Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDINTERESTRATECHANGE]: 'Next Scheduled Profit Rate Change',
  [IDS.MORTGAGE_DETAILS_LABEL_NEXTSCHEDULEDPRINCIPALANDINTERESTCHANGE]: 'Next Scheduled Installment Amount Change',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALINTERESTRATECHANGEDATE]: 'Original Profit Rate Change Date',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANAMOUNT]: 'Original Murabaha Debt',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALLOANDATE]: 'Original Murabaha Financing Closing Date',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALMORTGAGEAMOUNT]: 'Original Murabaha Debt',
  [IDS.MORTGAGE_DETAILS_LABEL_ORIGINALPICHANGEDATE]: 'Original Installment Amount Change Date',
  [IDS.MORTGAGE_DETAILS_LABEL_PRINCIPALANDINTEREST]: 'Installment Amount',
  [IDS.MORTGAGE_DETAILS_LABEL_PRINCIPALBALANCE]: 'Current Murabaha Debt',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_PRINCIPALBALANCE]: 'Current Murabaha Debt',
  [IDS.MORTGAGE_DETAILS_SUBHEADER_SECONDLOANPRINCIPALBALANCE]: 'Second Murabaha Financing Transaction Current Murabaha Debt',
  [IDS.MORTGAGE_DETAILS_TITLE]: 'Murabaha Financing Transaction Details',
  [IDS.MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_LOANTYPE]: 'Account Type',
  [IDS.MORTGAGE_TAXESINSURANCE_ESCROW_CARD_LABEL_ORIGINALLOANDATE]: 'Original Account Date',
  // Escrow
  [IDS.MORTGAGE_ESCROW_ADD_CONFIRMATION_LABEL_LOANNUMBER]: 'Account Number',
  [IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_1]: 'View the breakdown of installment amounts you will pay over time.',
  [IDS.MORTGAGE_ESCROW_SPLASH_BENEFITS_TEXT_2]: 'Make one monthly payment that includes your Murabaha Financing Transaction plus a percentage of other expenses.',
  [IDS.MORTGAGE_ESCROW_SPLASH_DEFINITION_CARD_TEXT]: 'A trust account in which the financier holds funds collected from a debtor and uses the money to pay taxes and insurance premiums when they become due. An initial escrow account is generally established at settlement. In some parts of the country, escrows of taxes and insurance premiums are called impounds or reserves. Escrow accounts are generally required by most financiers.',
  // Insurance Upload
  [IDS.MORTGAGE_ESCROW_INSURANCE_UPLOAD_LABEL_LOANNUMBER]: 'Account Number',
  // Shared
  [IDS.MORTGAGE_SHARED_BUTTON_LABEL_BACKTOMORTGAGE]: 'Back to Murabaha',
  [IDS.MORTGAGE_SHARED_BUTTON_LABEL_RETURNTOMORTGAGE]: 'Return to Murabaha',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
